module.exports = __webpack_public_path__ + "img/03.da1c2b3f.png";